module.exports = __webpack_public_path__ + "static/media/contact.64ea432b.jpg";